import React, { memo, useMemo } from 'react';
import i18n from 'i18next';

import icAreaCircle from '../../assets/imgs/ic_area_circle.svg?react';
import { convertToAbsoluteUrl, getValueByLanguage } from '../../utils';
import TextBreaks from '../TextBreaks/TextBreaks';
import styles from './styles.module.css';
import { OrderTicket, SpotInfo } from 'types';

interface BoughtSpotTicketProps {
    isTicketUsed: boolean;
    orderTicket: OrderTicket;
    spotInfo: SpotInfo;
}

const BoughtSpotTicket: React.FC<BoughtSpotTicketProps> = ({ isTicketUsed, orderTicket, spotInfo }) => {
    const { spotImage, spotName } = spotInfo ?? {};
    const imageUrl = useMemo(() => {
        const defaultUrl = '/images/spot-default-image.png';
        const spotImageUrl = convertToAbsoluteUrl(spotImage);
        return spotImageUrl && spotImage ? spotImageUrl : defaultUrl;
    }, [spotImage]);

    return (
        <>
            {orderTicket != null && (
                <>
                    <p className={styles.ticketName}>
                        <TextBreaks text={getValueByLanguage(orderTicket.ticketName, i18n.language)} />
                    </p>
                    <p className={styles.subtitle}>
                        <TextBreaks text={getValueByLanguage(spotName, i18n.language)} />
                    </p>
                    <div className={styles.spotImage}>
                        {React.createElement(icAreaCircle, {
                            className: `${styles.imageBorder} ${!isTicketUsed && styles.unused}`,
                        })}
                        <img src={imageUrl} alt="" />
                    </div>
                </>
            )}
        </>
    );
};

export default memo(BoughtSpotTicket);
